import { useEffect, useState } from "react";
import styles from "./style.module.scss";
import { SubAdminTable } from "../../../../components/parts";
import { useAuth } from "../../../../context/AuthProvider";
import { Loader } from "../../../../components/ui";
import jwtInterceoptor from "../../../../api/jwtInterceptor";
import { GET_API_URLS } from "../../../../utils/constant";

const SubAdmin = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const { auth, setAuth } = useAuth();

  useEffect(() => {
    jwtInterceoptor
      .get(GET_API_URLS.SUB_ADMIN_URL)
      .then((response) => {
        // console.log(response);
        setLoading(false);
        setAuth((prev) => ({ ...prev, sub_admin: response.data }));
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status === 403) {
          setError("You dont have permission to access this page.");
        } else {
          setError("There was a problem while loading the data.");
        }
        console.log("Error", error);
      });
  }, [setAuth]);

  return (
    <div className={styles.subAdminContainer}>
      {loading ? (
        <Loader />
      ) : error ? (
        <h3 style={{ textAlign: "center" }}>{error}</h3>
      ) : (
        <SubAdminTable subAdminData={auth.sub_admin} />
      )}
    </div>
  );
};

export default SubAdmin;
